"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import API from "@ym-framework/api-utils";
class GuesterPaymentAPI {
  // 匿名登录
  ghostLogin(clientId) {
    return __async(this, null, function* () {
      const response = yield API.post(`api://base/v1/gost`, {
        "clientId": clientId
      });
      return response.data;
    });
  }
  // 根据token获取用户信息
  getUserInfo() {
    return __async(this, null, function* () {
      const response = yield API.get(`api://base.auth/v1/account-infos`);
      return response.data;
    });
  }
}
export const guesterPaymentAPI = new GuesterPaymentAPI();
